import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import CatererContactModal from '../../shared/modal/CatererContactModal';

// action creators
import { appointmentListClear, appointmentListFetch } from '../../../actions/appointmentActions';

// components
import IndexRow from './_IndexRow';
import NoAppointments from '../../shared/_NoAppointments';
import { Panel, PanelHeader } from '../../shared/_panel';
import Spinner from '../../shared/_Spinner';
import { booksFetch } from '../../../actions/booksActions';
import DirectOfficeContactModal from './_DirectOfficeContactModal';
import { tooltipShow, tooltipHide } from '../../../actions/tooltipActions';
import Advertisement from '../../shared/_advertisement';
import { FOOD_ORDER_WEBSITE } from '../../../constants/foodOrder';

const MODAL_ID = 'DirectOfficeContactModal';
const CATERER_MODAL_ID = 'IndexCatererContactModal';

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map({
      currentMonth: moment().startOf('month')
    }) };
  }

  componentDidMount() {
    const { currentUser, fetchBooks, closeToStart, showModal } = this.props;

    if (closeToStart) {
      showModal({ id: MODAL_ID });
    }

    const repId = (currentUser.get('data') || Immutable.Map()).get('id');

    if (repId) {
      fetchBooks();
      this._initAppointments();
    }
  }

  componentWillReceiveProps(nextProps) {
    const currentRepId = (this.props.currentUser.get('data') || Immutable.Map()).get('id');
    const nextRepId    = (nextProps.currentUser.get('data') || Immutable.Map()).get('id');

    if (currentRepId !== nextRepId) {
      this._initAppointments(nextRepId);
    }
  }

  componentWillUnmount() {
    const { clearAppointments, router } = this.props;
    const isClickedElementAppointmentToolbar = router.params.date && router.params.id;

    if (!isClickedElementAppointmentToolbar) {
      clearAppointments();
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className='body__content rep-calendar-index'>
          <Panel>
            <Advertisement />
            <PanelHeader className={ 'panel__header--my-calendar' }>
              My Calendar
            </PanelHeader>
            <Spinner className='rep-calendar-index__list' enabled={ this._isLoading() }>
              { this._renderListItems() }
            </Spinner>
          </Panel>
        </div>
        <DirectOfficeContactModal id={ MODAL_ID } />
        <CatererContactModal id={ CATERER_MODAL_ID } onBack={ this._handleOnCatererClose } />
      </React.Fragment>
    );
  }

  _handleOnCatererClose = this._handleOnCatererClose.bind(this);
  _handleOnCatererOpen = this._handleOnCatererOpen.bind(this);

  _initAppointments(repId = this.props.currentUser.get('data').get('id')) {
    const { fetchAppointments } = this.props;

    const params = {
      repId: repId
    };

    fetchAppointments(params);
  }

  _isLoading() {
    const { appointment } = this.props;

    return appointment.get('loading') || false;
  }

  _renderListItems() {
    const items = this.__fetchItems();

    if (items.length === 0) {
      return (<NoAppointments key='nope' />);
    }

    return items;
  }

  __fetchItems() {
    const { appointment } = this.props;

    const items         = appointment.get('data') || Immutable.Map();
    const currentMonth  = this.state.data.get('currentMonth');
    const elements      = [];

    let startDate = moment();

    if (!currentMonth.isSame(startDate, 'month')) {
      startDate = currentMonth.startOf('month');
    }
    const itemsByKey = Object.keys(items.toJS());
    const sortedItemsByDate = itemsByKey.sort((a, b) => new Date(a) - new Date(b));
    const endDate = moment(sortedItemsByDate[sortedItemsByDate.length - 1]).add(1, 'day');

    for (let i = 0; i <= endDate.diff(startDate, 'days'); i++) {
      const item = items.get(moment(startDate).add(i, 'days').format('YYYY-MM-DD')) || Immutable.Map();

      if (item.size > 0) {
        elements.push(
          <IndexRow appointments={ item } date={ moment(startDate).add(i, 'days') } key={ i } />
        );
      }
    }

    return elements;
  }

  _handleOnCatererOpen() {
    const { showModal } = this.props;

    showModal({ id: CATERER_MODAL_ID });
  }

  _handleOnCatererClose() {
    const { hideModal } = this.props;

    hideModal({ id: CATERER_MODAL_ID });
  }
}

Index.propTypes = {
  appointment: PropTypes.instanceOf(Immutable.Map),
  clearAppointments: PropTypes.func.isRequired,
  closeToStart:  PropTypes.bool,
  currentUser: PropTypes.instanceOf(Immutable.Map),
  fetchAppointments: PropTypes.func.isRequired,
  fetchBooks:  PropTypes.func.isRequired,
  hideModal: PropTypes.func,
  showModal: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    appointment: state.get('appointment'),
    currentUser: state.get('currentUser'),
    closeToStart: state.getIn(['appointmentStatus', 'closeToStart'], false)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearAppointments: () => {
      dispatch(appointmentListClear());
    },

    fetchAppointments: (params) => {
      dispatch(appointmentListFetch(params));
    },

    fetchBooks: () => {
      dispatch(booksFetch());
    },
    hideModal: ({ id }) => dispatch(tooltipHide({ id })),
    showModal: ({ id }) => dispatch(tooltipShow({ id }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./app/components/reps/calendar/Index.jsx